import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const isEmailUsed = createApiThunk<boolean, string>("admins/isEmailUsed", async (email: string, { extra: { sharedRepository } }) => {
  return sharedRepository!.isEmailUsed(email);
});

export const resetIsEmailUsed = createAction("admins/resetIsEmailUsed");
